import { Center, Flex, Input, Text, VStack } from '@chakra-ui/react'
import { useState } from 'react'
import { ActionButton, SolidActionButton } from '../Buttons'
import { UsePdfPassword } from './hooks'

export const EnterPassword = ({
  pdfPassword,
  onClose,
}: {
  pdfPassword: UsePdfPassword
  onClose?: () => void
}) => {
  const [value, setValue] = useState('')

  const { requestingPassword, handlePassword, passwordError } = pdfPassword

  const handleSubmit = () => {
    handlePassword(value)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSubmit()
    }
  }

  if (!requestingPassword) return null
  return (
    <Center
      position="absolute"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="blackAlpha.500"
      zIndex={10}>
      <VStack w="100%" maxW="400px" p={3} bg="white" borderRadius={6}>
        <Text fontSize="lg" fontFamily="Open Sans">
          This document is password protected
        </Text>
        <Flex w="100%" gap={2} alignItems="center">
          <Input
            flex={1}
            value={value}
            onChange={e => setValue(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Password"
          />
          <SolidActionButton size="sm" onClick={handleSubmit}>
            Submit
          </SolidActionButton>
          {onClose ? (
            <ActionButton size="sm" onClick={onClose}>
              Close
            </ActionButton>
          ) : null}
        </Flex>
        {passwordError ? <Text color="red.600">{passwordError}</Text> : null}
      </VStack>
    </Center>
  )
}
